import { Button, Card } from "@fanduel/og-fe-library";
import cx from "classnames";
import { useState } from "react";
import styles from "./raceControls.module.scss";

const RaceLegend = () => {
  const [showLegend, setLegendVisibility] = useState(false);
  return (
    <div className={styles.btnContainer}>
      <Button
        buttonStyle="Outlined"
        buttonText="View Legend"
        rightIconName={showLegend ? "arrows.up" : "arrows.down"}
        onClick={() => setLegendVisibility((val) => !val)}
      />
      {showLegend ? (
        <Card
          elevation="mid"
          variant="elevation"
          className={cx(styles.legendContainer)}
        >
          <div className={styles.legend1}>
            <p>Power Rating</p>
            <p>
              This is a single number that showcases a horse&apos;s overall
              abilities in speed, class, and pace.
            </p>
          </div>
          <div className={styles.legend3}>
            <p>High Speed</p>
            <p>
              We take the running speeds from the horses previous outings and
              convert it into a rating you can user to see which one if fastest.
            </p>
          </div>
          <div className={styles.legend2}>
            <p>Top 3 %</p>
            <p>
              The number of times a horse has come in the top 3 in all the races
              it has run.
            </p>
          </div>

          <div className={styles.legend4}>
            <p>Win %</p>
            <p>
              The number of times a horse has come 1st out of all the races it
              has run.
            </p>
          </div>
          <div className={styles.legend5}>
            <p>Win Probability</p>
            <p>
              Our team of experts at numberFire provide an estimated Win
              Probability percentage for every single horse. This is based on
              what they expect the odds to be when the race begins. When there
              are scratched in a race, these odds will update accordingly,
              giving you the most accurate possible percentage.
            </p>
          </div>
        </Card>
      ) : (
        ""
      )}
    </div>
  );
};

export default RaceLegend;
